import React, { useState, useContext, useEffect } from 'react'

import { Modal, Popconfirm } from 'antd'
import { SwapRightOutlined } from '@ant-design/icons';
import GeneralContext from '../../context/GeneralContext/GeneralContext';
import api from '../../services/api'
import SL_Button from '../../components/buttons/Button';
import { displayMessage } from '../../services/helper';
import { DataGridPro, useGridApiRef } from '@mui/x-data-grid-pro';
import monitory_room_grid_columns from './grid_columns/monitory_room_grid_columns';

export default function WaitingRoom(props) {


    const {setShowLoading, windowHeight, mobile_mode, user, setUser,enums} = useContext(GeneralContext)

    const gridRef = useGridApiRef()
    const DataGridProHeight = windowHeight * 0.6

    const [controls, setControls] = useState(null)
    const [haveSomethingSelected, setHaveSomethingSelected] = useState(false)


    useEffect(() => {

        props.loadWaitingControls()
    }, [])

    useEffect(() => {
        setControls(props.waitingControls)
    }, [props.waitingControls])


    const handleWhatIsSelectedInGrid = () => {
        const _controls = []
        gridRef.current.getSelectedRows().forEach((e) => _controls.push(e))
        if (_controls.length > 0) {
            setHaveSomethingSelected(true)
        }
        else {
            setHaveSomethingSelected(false)
        }
    }

    const handleSendToExerciseRoom = async (controls) => {
        setShowLoading(true);
        try {
            let payload = props.formatControlsToArrayIds(controls)
            await api.dialy_controls.sendToExerciseRoom(user.id, payload).then(
                async err => {
                    let updatedUser = await api.user.get(user?.id)
                    setUser(updatedUser.data)
                }
            )
        } catch (error) {
            console.log(error)
        } finally {
            props.loadWaitingControls()
            props.handleOnCloseModal()
            setShowLoading(false);
        }
    }

    const handleCancel = async (controls) => {
        setShowLoading(true);
        try {
            let payload = props.formatControlsToArrayIds(controls)
            await api.dialy_controls.cancelWaitingRoom(user.id, payload)

        } catch (error) {
            let updatedUser = await api.user.get(user?.id)
            setUser(updatedUser.data)
            console.log(error)
        } finally {
            props.loadWaitingControls()
            setShowLoading(false);
        }
    }


    return (
        <Modal
            title={<div className="text-xl font-bold text-appian-blue">{displayMessage('WAITING_ROOM')}</div>}
            visible={props.isModalVisible}
            onCancel={props.handleOnCloseModal}
            centered={true}
            footer={[]}
            width={mobile_mode ? '95%' : '80%'}
            style={{ position: 'relative' }}
            bodyStyle={{ maxHeight: windowHeight * 0.8, overflow: 'auto', }}
        >
            <div className='flex flex-col' >
                <div className='flex flex-col'>
                    <div style={{ display: 'flex', flexDirection: 'column', marginRight: 5, marginBottom: 16 }}>
                        <div style={{ fontWeight: 'bold', color: '#1b3663', }}>{displayMessage('WAINTINGROOM_INTRO_TEXT')}</div>
                        <div style={{ color: '#1b3663', marginTop: 4, marginBottom: 8 }}> {displayMessage('WAINTINGROOM_EXPLANATION_TEXT')}</div>
                    </div>

                    <div style={{ display: 'flex', flex: 1, justifyContent: mobile_mode ? 'center' : 'flex-end', marginBottom: 10, columnGap: mobile_mode ? "" : 10, rowGap: mobile_mode ? 10 : "", flexDirection: mobile_mode ? 'column' : 'row' }}>
                        <Popconfirm
                            zIndex={10001}
                            placement={"bottomLeft"}
                            title={displayMessage('COMFIRMATION_SEND_TO_EXERCISE_ROOM')}
                            onConfirm={() => {
                                const _controls = []
                                gridRef.current.getSelectedRows().forEach((e) => _controls.push(e))
                                handleSendToExerciseRoom(_controls)
                            }}
                            okText={displayMessage('YES')}
                            cancelText={displayMessage('NO')}
                            disabled={user?.user_type != enums?.EUserTypes?.MONITOR?.code || haveSomethingSelected == false}
                        >
                            <SL_Button
                                style={{ fontWeight: 'bold', flex: mobile_mode ? 1 : '' }}
                                icon={<SwapRightOutlined />}
                                disabled={user?.user_type != enums?.EUserTypes?.MONITOR?.code || haveSomethingSelected == false}
                            >
                                {displayMessage('ADD_TO_EXERCISE_ROOM')}
                            </SL_Button>
                        </Popconfirm>

                        <Popconfirm
                            zIndex={10001}
                            placement={"bottomLeft"}
                            title={displayMessage('COMFIRMATION_CANCEL_WAITING_ROOM')}
                            onConfirm={() => {
                                const _controls = []
                                gridRef.current.getSelectedRows().forEach((e) => _controls.push(e))
                                handleCancel(_controls)
                            }}
                            okText={displayMessage('YES')}
                            cancelText={displayMessage('NO')}
                            disabled={user?.user_type != enums?.EUserTypes?.MONITOR?.code || haveSomethingSelected == false}
                        >
                            <SL_Button
                                style={{ fontWeight: 'bold', flex: mobile_mode ? 1 : '' }}
                                danger={true}
                                icon={<SwapRightOutlined />}
                                disabled={user?.user_type != enums?.EUserTypes?.MONITOR?.code || haveSomethingSelected == false}
                            >
                                {displayMessage('SEND_BACK_TO_MONITORY_ROOM')}
                            </SL_Button>
                        </Popconfirm>
                    </div>

                    {
                        controls &&
                        <div
                            style={{ height: DataGridProHeight, minHeight: 300 }}
                        >
                            <DataGridPro
                                rows={controls}
                                apiRef={gridRef}
                                style={{ height: '60vh' }}
                                density={"comfortable"}
                                columns={monitory_room_grid_columns}
                                pagination
                                pageSize={100}
                                disableMultipleSelection
                                checkboxSelection={true}
                                onSelectionModelChange={() => handleWhatIsSelectedInGrid()}
                            />

                        </div>
                    }
                </div>
            </div>
        </Modal >
    )
}